<template>
  <div class="w-full flex flex-col">
    <img src="@/assets/BodyAnalysis/body-shpae.svg" alt="" />

    <div class="flex flex-col mt-4 gap-4">
      <div v-for="i in 10" :key="i" class="measurement-item w-full">
        <div class="item-name flex flex-col">
          <span>{{ 'Fake' }}</span>
          <span class="item-rank" :class="{ 'over-rank': i > 5 }">{{
            i > 5 ? '超過標準' : '標準'
          }}</span>
        </div>
        <span class="item-value">{{ i }}</span>
        <span class="dropdown-icon"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalysisPage',
};
</script>

<style lang="scss" scoped>
.measurement-item {
  @apply w-full flex items-center p-4;
  height: 64px;
  color: #282828;
  font-style: normal;
  font-weight: 600;
  border: 1px solid #bfbfbf;
  border-radius: 8px;

  .item-name {
    height: 48px;
    width: 65%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
  }

  .item-rank {
    font-weight: 400;
    font-size: 12px;
    color: #1fc589;
  }

  .over-rank {
    color: #ffac46;
  }

  .item-value {
    height: 48px;
    font-size: 20px;
  }

  .dropdown-icon {
    @apply ml-auto;
    width: 20px;
    height: 48px;
    background: url('../../../assets/common/icon-expand.svg') top no-repeat;
  }
}
</style>
